<template>
  <div class="sample-page analysis-jobs-body">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/">Home</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item
          ><router-link to="/analysis">Run Jobs</router-link></a-breadcrumb-item
        >
        <a-breadcrumb-item>Help</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="analysis-jobs-main">
      <div class="analysis-jobs-header">
        <div class="analysis-jobs-face"></div>
        <div class="analysis-jobs-remarks">
          This website is free and open to all users and there is no login
          requirement.
        </div>
        <div class="analysis-jobs-subremarks">No cookies are required.</div>
      </div>
      <a-row>
        <a-col class="job-des-box" :lg="7" :md="9">
          <h1>How to use</h1>
          <h2 class="jdb-h2">CONTACT US</h2>
          <div class="job-des">
            <h2 class="job-des-sub">Liu Lab</h2>
            <p>
              Shanghai Children’s Medical Center, Shanghai Jiao Tong University,
              China
            </p>
            <p>
              Bowen Cui:
              <a href="javascript:;">xcxiongmao@126.com</a>
            </p>
            <p>
              Yu Liu:
              <a href="javascript:;">yu.liu@sjtu.edu.cn</a>
            </p>
          </div>
        </a-col>
        <a-col :lg="17" :md="15" class="job-run-box">
          <h4>
            <b>BALL6</b> is a machine learning tool for predicting acute leukemia (AL) and B-cell acute lymphoblastic leukemia (B-ALL) subtypes. It utilizes a well-trained bidirectional Long Short-Term Memory (LSTM) neural network model, supported by our novel rank-transformation-based data augmentation framework.

          </h4>
          <h4>
            To obtain a sample’s subtype prediction, users simply need upload a gene expression file, and the results will be presented immediately after a single click.
          </h4>
          <h3>Input Requirement</h3>
          <h4>
            The only input BALL6 requires is an genes expression table of 476 genes in a tab-separated format with two columns. The first column named ‘GeneName‘ should be the Ensembl gene IDs, and the last column should be gene expression values or rank values.
          </h4>
          <h4>
           Note that the BALL6 only requires 229 genes for the AL model and 292 genes for the BALL model, which means that the program will ignore any extra genes provided in the input. And if any of the required genes are missing, their values will be automatically set to 0.
          </h4>
          <h4>
            If the Ensembl gene IDs in the first column include version suffixes, the program will automatically remove them. BALL6 converts the input gene expression values into rank values, which help the model to mitigate batch effect across different data sources. So, it does not matter if the gene expression of your input is original values or not, what matters is the difference in values size between the genes.
          </h4>

          <h3>Results Explanation</h3>
          <h4>
          The prediction results consist of two parts, representing the AL model and the BALL model, respectively. The prediction subtype and its probability are displayed in the table, with the best prediction subtype shown in the first row. All probabilities are rounded to four significant digits.
          <br />
           The interactive polar plots are provided, visualizing the probability for each subtype. If the subtype probability exceeds than 0.9, its polar bar will be highlighted in red, while all other bars will be displayed in dark grey.
          </h4>
          <h3>Subtypes Category</h3>
          <h4>
           AL model: B-ALL (B-cell acute lymphoblastic leukemia), T-ALL (T-cell acute lymphoblastic leukemia), AML (acute myelocytic leukemia)
          </h4>
          <h4>
           BALL model: DUX4 (DUX4 fusion), ETV6::RUNX1 (ETV6::RUNX1 fusion), ETV6::RUNX1-like (expression profile highly similar to ETV6::RUNX1), Ph(BCR-ABL1 fusion), PHLIKE (BCR-ABL1-like fusion), KMT2A (KMT2A fusion), MEF2D (MEF2D fusion), TCF3::PBX1 (TCF3::PBX1 fusion), ZNF384 (ZNF384 fusion), ZNF384-like (expression profile highly similar to ZNF384), IKZF1 N159Y (IKZF1 N159Y mutation), MYC (IGH::MYC), PAX5alt (PAX5 fusion), PAX5 P80R (PAX5 P80R mutation), HYPER (hyperdiploid), IAMP21 (intrachromosomal amplification of chromosome 21), HYPO (hypodiploid), ZEB2/CEBP (ZEB2 H1038 or IGH::CEBPA).
          </h4>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicFile: process.env.BASE_URL,
      actionUrl: "api/open/ps/uploadFile",
      path: process.env.VUE_APP_ANALYSIS_PATH,
      fileList: [],
      steps: 1,
      resRunId: "",
      progress: 0,
      timer: null,
      statusTimer: null,
      jobsStatus: {},
      langTime: 800,
    };
  },
  mounted() {},
  methods: {
    openExample() {
      this.$router.push({
        path: "analysis/details",
        query: { jobsId: "run-example" },
      });
    },
    openCheckDetails() {
      if (this.jobsStatus.jobId) {
        this.$router.push({
          path: "analysis/details",
          query: { jobsId: this.jobsStatus.jobId },
        });
      } else {
        this.$message.error("Job does not exist!");
      }
    },
    handleRemove(file) {
      this.fileList = [];
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    // 上传前事件
    beforeUpload(file) {
      if (file.name.indexOf(".txt") == -1) {
        this.$message.error("Please upload the file with txt suffix.");
        return false;
      }
      this.fileList = [file];
      return true;
    },
    submitRun() {
      if (this.fileList.length == 0) {
        this.$message.error(
          "Please upload the file with the specified suffix of txt and run."
        );
      } else {
        this.$get("open/ps/job/submit", {
          fpkmFilename: this.fileList[0].response.data,
        }).then((res) => {
          if (res.data.code == 1) {
            this.steps = 2;
            this.resRunId = res.data.data;
            this.loadProgress();
            this.loadStatus(this.resRunId);
          }
        });
      }
    },
    loadProgress() {
      let $this = this;
      this.timer = setInterval(() => {
        if ($this.progress > 99 && $this.progress < 100) {
          clearInterval($this.timer);
        } else {
          $this.progress += 0.8;
          $this.progress = $this.progress.toFixed(2) * 1;
        }
      }, $this.langTime);
    },
    loadStatus(id) {
      let $this = this;
      this.statusTimer = setInterval(() => {
        if ($this.jobsStatus.status == "running") {
          $this.getJobsStatus(id);
        } else if ($this.jobsStatus.status == "done") {
          $this.progress = 100;
          $this.steps = 3;
          clearInterval($this.statusTimer);
        } else {
          clearInterval($this.statusTimer);
        }
      }, 3000);
      $this.getJobsStatus(id);
    },
    getJobsStatus(id) {
      let $this = this;
      this.$get("open/ps/job/status", {
        saasJobId: this.resRunId,
      }).then((res) => {
        if (res.data.code == 1) {
          this.jobsStatus = JSON.parse(res.data.data);
        } else {
          clearInterval($this.statusTimer);
        }
      });
    },
    randomTime(n, m) {
      return (Math.random() * (n - m) + m).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-jobs-body {
  background: white;
  padding-bottom: 0;
  .analysis-jobs-header {
    height: 309px;
    background: url("../../assets/image/analysis/group_2.png") no-repeat center;
    background-size: cover;
    background-position-y: inherit;
    padding-top: 85px;
  }
  .analysis-jobs-face {
    width: 50px;
    height: 41px;
    background: url("../../assets/image/analysis/smiling_face.png") no-repeat
      center;
    background-size: cover;
    margin: 0 auto;
    margin-bottom: 46px;
  }
  .analysis-jobs-remarks {
    font-size: 24px;
    text-align: center;
    color: #ffffff;
    line-height: 32px;
  }
  .analysis-jobs-subremarks {
    text-align: center;
    color: #ffffff;
  }
  .customhouse-breadcrumb {
    background: #e5e5e5;
    padding: 15px 20px;
  }

  .job-des-box {
    padding: 20px 40px;
    line-height: 25px;
    background: white;
    a {
      cursor: default;
    }
  }

  h1 {
    font-size: 3em;
    font-weight: 600;
    padding: 10px 0;
  }

  h2 {
    font-weight: 600;
    padding-top: 25px;
    span {
      display: inline-block;
      margin-right: 20px;
      color: white;
      padding: 2px 10px;
      background: #0162ff;
      border-radius: 20px;
    }
  }
  .job-run-box {
    padding: 20px 40px 50px 40px;
    h3 {
      margin-top: 25px;
      font-weight: 600;
      color: #162232;
    }
    h4 {
      font-weight: 400;
      margin-bottom: 0.8em;
    }
  }
  .jdb-h2 {
    font-size: 21px;
    font-weight: 600;
    color: #9b9b9b;
  }
  .job-des-sub {
    color: #294049;
    font-size: 16px;
    font-weight: 500;
    padding: 5px 0;
  }
}
</style>